import { type PaletteOptions } from '@mui/material/styles'
import { additional } from './dark-additional'
import { blue } from './dark-blue'
import { dhlRed } from './dark-dhl-red'
import { green } from './dark-green'
import { grey } from './dark-grey'
import { opacity } from './dark-opacity'
import { pure } from './dark-pure'

export const components: PaletteOptions['components'] = {
  avatar: {
    backgroundBlue: additional.vibrandBlue,
    border: grey[400],
  },
  backdrop: {
    fill: opacity.dark[600],
  },
  bottomNavigation: {
    contrast: dhlRed[700],
  },
  buttonLink: {
    hover: grey[600],
  },
  chip: {
    icon: opacity.dark[400],
    focus: grey[900],
    border: grey[400],
    hover: opacity.dark[150],
  },
  dataGrid: {
    zebraDark: grey[200],
    hover: 'rgba(255, 255, 255, 0.10)',
  },
  divider: {
    line: grey[300],
  },
  input: {
    background: pure.light,
  },
  link: {
    contrast: dhlRed[700],
  },
  navbar: {
    selected: opacity.dark[150],
    selectedHover: opacity.dark[150],
    contrast: pure.dark,
  },
  pageHeader: {
    default: grey[200],
    accept: green[200],
    test: blue[200],
    color: {
      contrast: pure.dark,
      default: pure.dark,
    },
  },
  switch: {
    fill: grey[300],
    hover: opacity.dark[50],
    focus: opacity.dark[80],
    border: grey[400],
    knobDisabled: grey[400],
  },
}
